import { toast } from "sonner";

/**
 * Copy `text` to clipboard with graceful fallback.
 * Silences NotAllowedError in headless / insecure contexts where
 * `navigator.clipboard` is unavailable or blocked.
 */
export async function copyToClipboard(text, successMsg = "Copied") {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    if (successMsg) toast.success(successMsg);
    return true;
  } catch (e) {
    toast.error("Copy failed — please copy manually");
    return false;
  }
}
